import { PostHogErrorBoundary, PostHogProvider } from "posthog-js/react";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./styles/design-tokens.css";
import { envConfig } from "@/lib/config";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error('Root element with id "root" not found');
}
const posthogKey = envConfig.POSTHOG.KEY;
const hasPosthog = !!posthogKey;

if (!hasPosthog) {
  console.warn("PostHog not initialized: missing VITE_PUBLIC_POSTHOG_KEY");
}

const app = (
  <React.StrictMode>
    {hasPosthog ? (
      <PostHogProvider
        apiKey={posthogKey}
        options={{
          api_host: envConfig.POSTHOG.HOST,
          defaults: "2025-05-24",
          capture_exceptions: true, // This enables capturing exceptions using Error Tracking
          debug: envConfig.IS_DEV,
        }}
      >
        <PostHogErrorBoundary>
          <App />
        </PostHogErrorBoundary>
      </PostHogProvider>
    ) : (
      <App />
    )}
  </React.StrictMode>
);

createRoot(rootElement).render(app);
